export default {
      id: "menu-points-usage",
      viewBox: "0 0 26 6",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#menu-points",
      toString: function () {
        return this.url;
      }
    }